export type CategoryMetaTypes = {
  [Product: string]: {
    [Category: string]: {
      displayName: string;
      order: number;
    };
  };
};

export const metricsCategoryMeta: CategoryMetaTypes = {
  ei: {
    VIDEO_ENGAGEMENT: {
      displayName: 'Audience and Engagement',
      order: 1,
    },
    VIDEO_SPI: {
      displayName: 'SPI and KPI Metrics',
      order: 2,
    },
    VIDEO_STARTUP: {
      displayName: 'Startup Experience',
      order: 3,
    },
    VIDEO_PLAYBACK: {
      displayName: 'Playback Experience',
      order: 4,
    },
    VIDEO_AD_EXPERIENCE: {
      displayName: 'Ad Experience',
      order: 5,
    },
  },
  ai: {
    AD_ENGAGEMENT: {
      displayName: 'Audience and Engagement',
      order: 1,
    },
    AD_EXPERIENCE: {
      displayName: 'Ad Experience',
      order: 2,
    },
  },
  app: {
    ECO_AUDIENCE: {
      displayName: 'Audience and Engagement',
      order: 1,
    },
    ECO_QOE: {
      displayName: 'QoE and KPI Metrics',
      order: 2,
    },
    ECO_ENGAGEMENT: {
      displayName: 'Engagement',
      order: 3,
    },
    ECO_FRUSTRATION_SIGNALS: {
      displayName: 'Frustration Signals',
      order: 4,
    },
    ECO_WEB_USER_EXPERIENCE: {
      displayName: 'Web User Experience',
      order: 5,
    },
    ECO_APP_USER_EXPERIENCE: {
      displayName: 'Mobile User Experience',
      order: 6,
    },
    ECO_SERVICE_PERFORMANCE: {
      displayName: 'Service Performance',
      order: 7,
    },
    ECO_USER_DEFINED_METRICS: {
      displayName: 'Custom Metrics',
      order: 8,
    },
    ECO_SIGNAL_EVENT: {
      displayName: 'Signal Event',
      order: 9,
    },
    // Only applicable for eco flow preset
    global: {
      displayName: 'Global',
      order: 10,
    },
    flow: {
      displayName: 'Flow',
      order: 11,
    },
    errors: {
      displayName: 'Error',
      order: 12,
    },
    network: {
      displayName: 'Network Request',
      order: 13,
    },
  },
  odp: {
    ODP: {
      displayName: 'ODP',
      order: 1,
    },
    ECO_USER_DEFINED_METRICS: {
      displayName: 'Custom Metrics',
      order: 2,
    },
  },
};
